import { colors } from './colors';
import CheckIcon from '@mui/icons-material/Check';
import PublishedWithChangesOutlinedIcon from '@mui/icons-material/PublishedWithChangesOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import StartIcon from '@mui/icons-material/Start';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CachedIcon from '@mui/icons-material/Cached';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PaletteIcon from '@mui/icons-material/Palette';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PrintIcon from '@mui/icons-material/Print';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
// adding new icon requires an explanatory comment and htmlColor
/**
 * icons that can be used through the program, for statuses, for buttons, etc.
 * colors have been added to them, if an icon with a different color scheme is needed,
 * add it here and change the color
 */
export const icons = {
  FORWARD_ARROW: <ArrowForwardIcon htmlColor={colors.WHITE} />,
  ATRIBUT_ICON: <PaletteIcon />,
  BACKWARD_ARROW: <ArrowBackIcon htmlColor={colors.WHITE} />,
  CHECK_ICON: <CheckIcon htmlColor={colors.SUCCESS_ICON} />,
  CHECK_ICON_: <CheckIcon htmlColor={colors.WHITE} />,
  DONE_ICON: <DoneAllIcon htmlColor={colors.DARK_PURPLE} />,
  CLOSE_ICON: <CloseOutlinedIcon htmlColor={colors.ERROR_ICON} />,
  CLOSE_ICON_: <CloseOutlinedIcon htmlColor={colors.WHITE} />,
  AUTOCOMPLETE_CLOSE: <CloseOutlinedIcon htmlColor={colors.AUTOCOMPLETE} />,
  IN_PROGRESS_ICON: (
    <PublishedWithChangesOutlinedIcon htmlColor={colors.WARNING_ICON} />
  ),
  MENU_ICON: <MoreVertIcon fontSize="medium" htmlColor={colors.MENU_ICON} />,
  DELETE_ICON: <DeleteIcon htmlColor={colors.DELETE} />,
  DELETE_ICON_WHITE: <DeleteIcon htmlColor={colors.WHITE} />,
  EDIT_ICON: <EditIcon htmlColor={colors.EDIT} />,
  EDIT_ICON_WHITE: <EditIcon htmlColor={colors.WHITE} />,
  DIALOG_CHECK: <CheckIcon htmlColor={colors.WHITE} />,
  DIALOG_CLOSE: <CloseOutlinedIcon htmlColor={colors.ORANGE} />,
  SAVE_BUTTON_ICON: <SaveIcon htmlColor={colors.WHITE} />,
  UPLOAD_ICON: <FileUploadIcon htmlColor={colors.UPLOAD} />,
  PENDING_ICON: <PublishedWithChangesIcon htmlColor={colors.WARNING_ICON} />,
  START_ICON: <StartIcon htmlColor={colors.SUCCESS_TEXT} />,
  STOP_ICON: <DoNotDisturbIcon htmlColor={colors.ERROR_TEXT} />,
  ADD_ICON: <AddIcon htmlColor={colors.WHITE} />,
  SEARCH_ICON: <SearchIcon htmlColor={colors.WHITE} />,
  REFRESH_ICON: <CachedIcon htmlColor={colors.WHITE} />,
  DOWNLOAD_ICON: <DownloadForOfflineIcon htmlColor={colors.WHITE} />,
  PREVIEW_ICON: <VisibilityIcon htmlColor={colors.DIALOG_PRIMARY} />,
  PREVIEW_ICON_WHITE: <VisibilityIcon htmlColor={colors.WHITE} />,
  PRINT_ICON: <PrintIcon htmlColor={colors.WHITE} />,
  COPY_ICON: <ContentCopyIcon htmlColor={colors.WHITE} />,
  SHOP_ICON: <AddShoppingCartIcon htmlColor={colors.WHITE} fontSize="large" />,
  SHOP_ICON_ORANGE: (
    <AddShoppingCartIcon htmlColor={colors.ORANGE} fontSize="large" />
  ),
  PICTURE_ICON: (
    <InsertPhotoIcon fontSize="medium" htmlColor={colors.MENU_ICON} />
  ),
};
